<template>

</template>

<script>
export default {
  name: 'tanChuang'
}
</script>

<style scoped>

</style>